import type { IncomingMessage } from 'http';

export function incomingMessageHeaders(res: IncomingMessage): Record<string, string> {
  const headers: Record<string, string> = {};
  for (const [k, v] of Object.entries(res.headers)) {
    if (typeof v === 'string') headers[k] = v;
    else if (Array.isArray(v) && v[0]) headers[k] = v[0];
  }
  return headers;
}
